/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeActionItem,
  BaSeDialogContext,
  BaSeGrid,
  BaSeGridItem,
  BaSeHeading6,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import * as React from 'react';
import { useInterviewController } from '../../../../../../hooks/controllers/interview-controller';
import { useManageClassController } from '../../../../../../hooks/controllers/manage-class-controller';
import { useReportController } from '../../../../../../hooks/controllers/report-controller';
import { useMessage } from '../../../../../../hooks/messages/useMessage';
import { useModule } from '../../../../../../hooks/module/module';
import { useManageClassService } from '../../../../../../hooks/services/manage-class-service';
import { useQuizProfileService } from '../../../../../../hooks/services/quiz-profile-service';
import { NewClassRoomContext } from '../../context/new-class-room-context';
import FormEditClassRoom from '../form-new-class-room/formEditClassRoom';
import ModalGenerateCertificate from '../modal-generate-certificate/modal-generate-certificate';
import {
  ContentDialog,
  ContentHeader,
  WrapperCandidatesWithoutQuestionnaire,
  WrapperDialogReportCompreteError,
} from './manage-class-style';

export const HeaderComponent = ({
  items,
  hasActionItem,
  beginDate,
  endDate,
  idClassRoom,
  type,
  seminarValue,
  title,
  active,
  isOwner,
  backgrounColor,
  hidePortal,
  regional,
}) => {
  const { getLinkReportClassRoom, downloadPdf } = useReportController();
  const { showModal } = React.useContext(BaSeDialogContext);
  const { handleError, handleAttention, handleSuccess } = useMessage();
  const { moduleSelected } = useModule();
  const { toggleClass } = useManageClassService();

  const { getSimpleBoardItemsData } = useManageClassController();
  const { getClassRoomByIdC } = useManageClassController();

  const { postSendInterviewCertificate, getDownloadCertificate } =
    useInterviewController();
  const { filters, handleColumns } = React.useContext(NewClassRoomContext);

  const { sendQuizLote } = useQuizProfileService();
  const colorItemMenu = BaSeTheme.colors.institucionais.cinzaSebrae45;

  const returnAction = React.useCallback(() => {
    const isActive = regional?.active ?? active;
    return isActive ? 'Desativar' : 'Ativar';
  }, [active, regional]);

  const returnIcon = React.useCallback(() => {
    const isActive = regional?.active ?? active;
    return isActive ? 'ban' : 'system/arrow-go-back-fill';
  }, [active, regional]);

  const actionText = returnAction();
  const icon = returnIcon();

  const openDialogGenerateCertificate = React.useCallback(
    (values, initialDate, finishDate) => {
      return showModal({
        actions: [],
        size: 'small',
        title: 'Gerar certificado',
        isFluid: true,
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <ModalGenerateCertificate
            begin={initialDate}
            end={finishDate}
            values={values}
            closeModal={closeModal}
          />
        ),
        onChooseAction: (action) => {
          console.log('ACTION', action);
        },
      });
    },
    [showModal],
  );

  const openDialogErrorReport = React.useCallback(
    (message, candidatesWithoutQuestionnaire) => {
      return showModal({
        actions: [],
        size: 'small',
        title: 'Atenção',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <WrapperDialogReportCompreteError withAutoScroll>
            <div>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae60}
              >
                Para a emissão do relatório de turma, é necessário que todos os
                participantes tenham concluído o preenchimento do relatório de
                perfil.
              </BaSeParagraph>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae60}
              >
                Os seguintes participantes não possuem o relatório preenchido:
              </BaSeParagraph>
            </div>
            <WrapperCandidatesWithoutQuestionnaire>
              {candidatesWithoutQuestionnaire.map((name) => (
                <BaSeSmall1
                  color={BaSeTheme.colors.institucionais.cinzaSebrae60}
                >
                  {name}
                </BaSeSmall1>
              ))}
            </WrapperCandidatesWithoutQuestionnaire>
          </WrapperDialogReportCompreteError>
        ),
        onChooseAction: (action) => {
          console.log('ACTION', action);
        },
      });
    },
    [showModal],
  );

  const openDialogConfirmEmailAutoavaliation = React.useCallback(
    (lista) => {
      return showModal({
        actions: [
          {
            action: 'Sim',
            type: 'primary',
            color: BaSeTheme.colors.defaultColors.black,
          },
          {
            action: 'Não',
            type: 'secondary',
          },
        ],
        size: 'large',
        title: 'Enviar e-mail de autoavaliação',
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <ContentDialog>
            <BaSeHeading6
              color={BaSeTheme.colors.feedbackInterface.atencao55}
              isBold={true}
            >
              Atenção!
            </BaSeHeading6>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              Existe(m) entrevista(s) na turma com o status{' '}
              <strong>"Certificada"</strong> e/ou <strong>"Desistente"</strong>.
            </BaSeParagraph>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              O envio do e-mail de autoavaliação será realizado somente para
              a(s) entrevista(s) com status <strong>"Finalizada"</strong>.
            </BaSeParagraph>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              Deseja continuar?
            </BaSeParagraph>
          </ContentDialog>
        ),
        onChooseAction: (action) => {
          if (action === 'Sim') {
            sendQuizLote(lista)
              .then(() => {
                handleSuccess('E-mail de autoavaliação enviado com sucesso!');
              })
              .catch((error) => {
                handleError(
                  error.message ?? 'Falha ao enviar e-mail de auto avaliação!',
                );
              });
          }
        },
      });
    },
    [showModal, sendQuizLote, handleSuccess, handleError],
  );

  const filter = React.useMemo(() => {
    return {
      pageIndex: 0,
      pageSize: 100,
      idClassRoom,
      type,
      myRecords: false,
    };
  }, [idClassRoom, type]);

  const handleUpdateColumns = React.useCallback(() => {
    handleColumns(filters);
  }, [filters, handleColumns]);

  const generateReportClass = React.useCallback(() => {
    getLinkReportClassRoom(idClassRoom)
      .then((data) => {
        if (data.isSuccess) {
          window.open(data.url, '_blank');
          return;
        }
        openDialogErrorReport(
          data.messageError,
          data.candidatesWithoutQuestionnaire,
        );
      })
      .catch((error) => console.log(error.message));
  }, [getLinkReportClassRoom, idClassRoom, openDialogErrorReport]);

  const openDialogConfirmGenerateReport = React.useCallback(() => {
    return showModal({
      actions: [
        {
          action: 'Sim',
          type: 'primary',
          color: BaSeTheme.colors.defaultColors.black,
        },
        {
          action: 'Não',
          type: 'secondary',
        },
      ],
      size: 'large',
      title: 'Gerar relatório da turma',
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      content: ({ closeModal, emitEvent }) => (
        <ContentDialog>
          <BaSeHeading6
            color={BaSeTheme.colors.feedbackInterface.atencao55}
            isBold={true}
          >
            Atenção!
          </BaSeHeading6>

          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            Existe(m) entrevista(s) na turma com o status{' '}
            <strong>"Desistente"</strong>.
          </BaSeParagraph>

          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            O relatório de perfil será gerado somente para a(s) entrevista(s)
            com status <strong>"Finalizada"</strong> e{' '}
            <strong>"Certificada"</strong>
          </BaSeParagraph>

          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            Deseja continuar?
          </BaSeParagraph>
        </ContentDialog>
      ),
      onChooseAction: (action) => {
        if (action === 'Sim') {
          generateReportClass();
        }
      },
    });
  }, [showModal, generateReportClass]);

  const openDialogConfirmGenerateCertificated = React.useCallback(
    (intensAceptrd, dataInicio, dataFim) => {
      return showModal({
        actions: [
          {
            action: 'Sim',
            type: 'primary',
            color: BaSeTheme.colors.defaultColors.black,
          },
          {
            action: 'Não',
            type: 'secondary',
          },
        ],
        size: 'large',
        title: 'Gerar certificado da turma',
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <ContentDialog>
            <BaSeHeading6
              color={BaSeTheme.colors.feedbackInterface.atencao55}
              isBold={true}
            >
              Atenção!
            </BaSeHeading6>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              Existe(m) entrevista(s) na turma com o status{' '}
              <strong>"Certificada"</strong> e/ou <strong>"Desistente"</strong>.
            </BaSeParagraph>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              A geração do certificado será realizada somente para a(s)
              entrevista(s) com status <strong>"Finalizada"</strong>.
            </BaSeParagraph>

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              Deseja continuar?
            </BaSeParagraph>
          </ContentDialog>
        ),
        onChooseAction: (action) => {
          if (action === 'Sim') {
            openDialogGenerateCertificate(intensAceptrd, dataInicio, dataFim);
          }
        },
      });
    },
    [openDialogGenerateCertificate, showModal],
  );

  const handleRegistrationData = async () => {
    try {
      const idModule = moduleSelected?.id ?? 1;

      const listItems = await getSimpleBoardItemsData({
        params: filter,
        idModule,
      });

      const dataInicio = new Date(`${beginDate} 21:00:00 GMT-0300`);
      const dataFim = new Date(`${endDate} 21:00:00 GMT-0300`);

      const containsDesistentOrCertificated = listItems.items.some(
        (item) =>
          item.statusCompletingInterview === 'DESISTENTE' ||
          item.statusCompletingInterview === 'CERTIFICADA',
      );

      const intensAceptrd = listItems.items.filter(
        (interview) =>
          interview.statusCompletingInterview !== 'DESISTENTE' &&
          interview.statusCompletingInterview !== 'CERTIFICADA',
      );
      if (intensAceptrd.length === 0) {
        handleAttention(
          'Todas as entrevistas da turma estão com o status "Certificada" e/ou "Desistente". A emissão do certificado somente é permitida para as entrevistas com o status"Finalizada".',
        );
        return;
      }
      if (containsDesistentOrCertificated) {
        openDialogConfirmGenerateCertificated(
          intensAceptrd,
          dataInicio,
          dataFim,
        );
        return;
      }
      openDialogGenerateCertificate(intensAceptrd, dataInicio, dataFim);
    } catch (error) {
      handleError('Houve um erro para carregar os candidatos!');
    }
  };

  const handleSendEmailAutoavaliation = async () => {
    try {
      const idModule = moduleSelected?.id ?? 1;

      const listItems = await getSimpleBoardItemsData({
        params: filter,
        idModule,
      });

      const intensAceptrd = listItems.items.filter(
        (interview) =>
          interview.statusCompletingInterview !== 'DESISTENTE' &&
          interview.statusCompletingInterview !== 'CERTIFICADA',
      );
      if (intensAceptrd.length === 0) {
        handleAttention(
          'Todas as entrevistas da turma estão com o status "Certificada" e/ou "Desistente". O envio do e-mail de autoavaliação somente é permitido para entrevistas com o status "Finalizada".',
        );
        return;
      }

      const isAllCertified = await listItems.items.every(
        (item) => item.statusCompletingInterview === 'CERTIFICADA',
      );

      if (isAllCertified) {
        handleAttention(
          'Todas as entrevistas da turma estão com status "Certificada". O envio do e-mail de autoavaliação somente é permitido para entrevistas com o status "Finalizada".',
        );
        return;
      }

      const containsCertificated = listItems.items.some(
        (item) =>
          item.statusCompletingInterview === 'CERTIFICADA' ||
          item.statusCompletingInterview === 'DESISTENTE',
      );
      const itemsFiltered = listItems.items.filter(
        (item) => item.statusCompletingInterview === 'FINALIZADA',
      );

      if (containsCertificated) {
        openDialogConfirmEmailAutoavaliation(
          itemsFiltered
            .map((item) => `interviews=${item.idInterview}`)
            .join('&'),
        );
        return;
      }

      if (itemsFiltered > 100) {
        handleAttention(
          'Somente é permitido selecionar um máximo de 100 entrevistas para o envio do e-mail de autoavaliação em lote.',
        );
        return;
      }

      await sendQuizLote(
        itemsFiltered.map((item) => `interviews=${item.idInterview}`).join('&'),
      );
      handleSuccess('E-mail de autoavaliação enviado com sucesso!');
    } catch (error) {
      handleError('Houve um erro ao enviar e-mail de auto avaliaçao em lote!');
      return;
    }
  };

  const handleSendCertificate = async () => {
    try {
      const idModule = moduleSelected?.id ?? 1;

      const listItems = await getSimpleBoardItemsData({
        params: filter,
        idModule,
      });

      const itemsFilteredToStatus = listItems.items.filter(
        (it) => it.statusCompletingInterview === 'CERTIFICADA',
      );

      const dto = {
        idsInterviews: itemsFilteredToStatus.map((it) => it.idInterview),
        sendAll: false,
      };

      await postSendInterviewCertificate(dto);
    } catch (error) {
      handleError('Houve um erro ao enviar os certificados!');
    }
  };

  const handleGetLinkReportClassRoom = React.useCallback(async () => {
    try {
      const idModule = moduleSelected?.id ?? 1;

      const listItems = await getSimpleBoardItemsData({
        params: filter,
        idModule,
      });

      const containsDesistent = listItems.items.some(
        (item) => item.statusCompletingInterview === 'DESISTENTE',
      );

      const isAllDesistent = listItems.items.every(
        (item) => item.statusCompletingInterview === 'DESISTENTE',
      );

      if (isAllDesistent) {
        handleAttention(
          'Todas as entrevistas da turma estão com o status "Desistente". A geração do relatório somente é permitida para as entrevistas com o status "Finalizada" ou "Certificada".',
        );
        return;
      }
      if (containsDesistent) {
        openDialogConfirmGenerateReport();
        return;
      }
      generateReportClass();
    } catch (error) {
      console.log(error.message);
    }
  }, [
    moduleSelected,
    handleAttention,
    getSimpleBoardItemsData,
    filter,
    generateReportClass,
    openDialogConfirmGenerateReport,
  ]);

  const handlePrintCertificate = React.useCallback(async () => {
    try {
      const idModule = moduleSelected?.id ?? 1;

      const listItems = await getSimpleBoardItemsData({
        params: filter,
        idModule,
      });

      const itemsFilteredToStatus = listItems.items.filter(
        (it) => it.statusCompletingInterview === 'CERTIFICADA',
      );

      const idList = itemsFilteredToStatus.map((it) => it.idInterview);

      getDownloadCertificate(idList).then((response) => {
        response && downloadPdf(response, 'certificado.pdf');
      });
    } catch (error) {
      handleError('Houve um erro ao fazer o download certificados!');
    }
  }, [
    downloadPdf,
    filter,
    getDownloadCertificate,
    getSimpleBoardItemsData,
    handleError,
    moduleSelected,
  ]);

  const abrirModalEdicao = React.useCallback(async () => {
    try {
      //const dataClassRooom = await getClassRoomByIdC(idClassRoom);
      // console.log('Terminando: ' + dataClassRooom);

      const dataClassRooom = await getClassRoomByIdC(idClassRoom);
      const nameTurma = dataClassRooom.className.split(':')[0];
      showModal({
        title: `Editar turma: ${nameTurma}`,
        size: 'small',
        content: ({ closeModal }) => (
          <FormEditClassRoom
            classData={dataClassRooom}
            closeFormEditClass={closeModal}
            nameTurma={nameTurma}
            handleUpdateColumns={handleUpdateColumns}
          />
        ),
        actions: [],
      });
    } catch (error) {
      handleError('Erro ao carregar os dados da turma para edição!');
    }
  }, [
    getClassRoomByIdC,
    idClassRoom,
    showModal,
    handleUpdateColumns,
    handleError,
  ]);

  const handleDisabledClass = React.useCallback(async () => {
    showModal({
      title: `${actionText} turma`,
      size: 'large',
      actions: [
        {
          action: 'Sim',
          type: 'primary',
          color: BaSeTheme.colors.defaultColors.black,
        },
        {
          action: 'Não',
          type: 'secondary',
        },
      ],
      content: ({ closeModal }) => (
        <BaSeGrid>
          <BaSeGridItem>
            <BaSeHeading6
              color={BaSeTheme.colors.feedbackInterface.atencao55}
              isBold={true}
            >
              Atenção!
            </BaSeHeading6>
          </BaSeGridItem>
          <BaSeGridItem>
            <BaSeParagraph>
              Tem certeza que deseja <strong>{actionText.toLowerCase()}</strong>{' '}
              a turma <strong>{title}</strong>?
            </BaSeParagraph>
          </BaSeGridItem>
        </BaSeGrid>
      ),
      onChooseAction: (action) => {
        if (action === 'Sim') {
          toggleClass(idClassRoom)
            .then(() => {
              handleSuccess(
                active
                  ? 'Turma desativada com sucesso.'
                  : 'Turma ativada com sucesso.',
              );
              handleUpdateColumns();
            })
            .catch((error) => {
              if (
                error.error === 'class-rom-cannot-be-disabled' ||
                error.errorCode === 'class-rom-cannot-be-disabled'
              ) {
                handleAttention(
                  error.message ?? 'Houve um erro ao desativar a turma.',
                );
              } else {
                handleError(
                  error.message ?? 'Houve um erro ao desativar a turma.',
                );
              }
            });
        }
      },
    });
  }, [
    showModal,
    actionText,
    title,
    toggleClass,
    idClassRoom,
    handleSuccess,
    active,
    handleUpdateColumns,
    handleAttention,
    handleError,
  ]);

  const optionsDisabledClass = [
    {
      text: `Valor do seminário: ${new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(seminarValue)}`,
      callback: () => {},
      color: colorItemMenu,
    },
    {
      callback: () => abrirModalEdicao(),
      icon: 'design/edit-2-line',
      text: 'Editar turma',
      color: colorItemMenu,
    },

    {
      callback: () => handleDisabledClass(),
      icon: icon,
      text: `${actionText} turma`,
      color: colorItemMenu,
    },
  ];
  const options = [
    {
      text: `Valor do seminário: ${new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(seminarValue)}`,
      callback: () => {},
      color: colorItemMenu,
    },
    {
      callback: () => handleGetLinkReportClassRoom(),
      icon: 'document-info',
      text: 'Gerar relatório',
      color: colorItemMenu,
    },
    {
      callback: () => handleSendEmailAutoavaliation(),
      icon: 'envelope',
      text: 'Enviar e-mail de autoavaliação',
      color: colorItemMenu,
    },
    {
      callback: () => handleRegistrationData(),
      icon: 'document/newspaper-line',
      text: 'Gerar certificado',
      color: colorItemMenu,
    },
    {
      callback: () => handleSendCertificate(),
      icon: 'document/newspaper-line',
      text: 'Enviar certificado',
      color: colorItemMenu,
    },
    {
      callback: () => handlePrintCertificate(),
      icon: 'business/printer-line',
      text: 'Imprimir certificado',
      color: colorItemMenu,
    },
    {
      callback: () => abrirModalEdicao(),
      icon: 'design/edit-2-line',
      text: 'Editar turma',
      color: colorItemMenu,
    },

    {
      callback: () => handleDisabledClass(),
      icon: icon,
      text: `${actionText} turma`,
      color: colorItemMenu,
    },
  ];
  const optionsFiltered =
    moduleSelected?.id !== 2
      ? options.filter((i) => i.text !== 'Enviar e-mail de autoavaliação')
      : options;

  const returnOptions = () => {
    const isActive = regional?.active ?? active;
    return isActive && active ? optionsFiltered : optionsDisabledClass;
  };

  return (
    <ContentHeader>
      {hasActionItem && (
        <BaSeActionItem
          closeOnAction
          color={BaSeTheme.colors.defaultColors.white}
          icon="ellipsis-v"
          items={returnOptions()}
          minWidth="300px"
          position="top-right"
          type="tertiary"
        />
      )}
    </ContentHeader>
  );
};
